import "animate.css";
import "./Contact.scss";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideContactDialog,
  selectContactDialogVisible,
} from "../../../app/appSlice";
import Dialog from "../../../valtra/components/Dialog";
import { selectText } from "../../../translation/translationSlice";

function Contact({ children, className }) {
  const dispatch = useDispatch();
  const t = useSelector(selectText);
  const visible = useSelector(selectContactDialogVisible);

  if (!visible) {
    return null;
  }

  return (
    <div
      className={"Contact" + (className ? ` ${className}` : "")}
      onClick={(e) => dispatch(hideContactDialog())}
    >
      <Dialog
        className="animate__animated animate__fadeInUp"
        onClose={(e) => dispatch(hideContactDialog())}
      >
        <h2>{t("ui-contact-us")}</h2>
        <p>{t("ui-contact-desc")}</p>
        <div className="contact-buttons">
          <a href="https://www.valtra.com/dealer-locator.html" target="_blank">
            {t("ui-find-dealer")}
          </a>
          <a
            href="https://www.valtra.com/the-journey-continues"
            target="_blank"
          >
            {t("ui-request-demo")}
          </a>
          <a
            href="https://www.valtra.com/the-journey-continues"
            target="_blank"
          >
            {t("ui-contact-us")}
          </a>
        </div>
      </Dialog>
    </div>
  );
}

export default Contact;
